'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
interface ComplianceErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ComplianceError({ error, reset }: ComplianceErrorProps) {
  const t = useTranslations('compliance');

  useEffect(() => {
    console.error('Compliance page error:', error);
  }, [error]);

  return (
    <main className="min-h-screen flex items-center justify-center">
      <div className="container mx-auto px-4 max-sm:px-4">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">{t('error.title')}</h1>
          <p className="text-xl text-gray-600 mb-8">{t('error.message')}</p>
          <div className="space-x-4">
            <button
              onClick={() => reset()}
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
            >
              Try again
            </button>
            <a
              href="/"
              className="inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
            >
              Go home
            </a>
          </div>
          {error.digest && <p className="mt-8 text-sm text-gray-500">Error ID: {error.digest}</p>}
        </div>
      </div>
    </main>
  );
}
